module.exports = __webpack_public_path__ + "static/img/liveLink.c846494.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/liveLink.png
// module id = PfS6
// module chunks = 46